import type { SessionUser } from 'src/shared/store/authStore';

export const ROLE_LABELS: Record<SessionUser['role'], string> = {
  owner: 'Propietaria',
  manager: 'Encargada',
  staff: 'Profesional',
};

/**
 * Owner and manager: the roles accountable for money and for the calendar's
 * rules. Mirrors the server's `RESOURCE_ROLES` for `finance:read`,
 * `appointments:override` and friends, and decides only what to *offer*.
 */
export const isManager = (role: SessionUser['role'] | undefined): boolean =>
  role === 'owner' || role === 'manager';
